import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

// utility/TextMore.jsの移植 ドロワー周りは未実装
/**
 * @example
 * <div data-controller="text-more">
 *  <button data-text-more-target="button" data-action="text-more#toggle">Toggle</button>
 *  <div data-text-more-target="content">content</div>
 * </div>
 */
// dummyButton: HTML要素はボタンではないが、画面上の表示・非表示の制御が必要な要素。
export class TextMoreController extends Controller {
  static values = { open: Boolean };
  static targets = ["content", "button", "dummyButton"];

  connect() {
    this.$content = $(this.contentTarget);
    this.$button = $(this.buttonTarget);
    if (this.hasDummyButtonTarget) this.$dummyButton = $(this.dummyButtonTarget);
    this.showButton();
    if (this.openValue) this.buttonTarget.click();
    // stimulus-use使ったほうがいいか？
    window.addEventListener("resize", this.handleResize);
    // ボタンの初期テキストを保存
    this.initialButtonText = this.$button.text();
    // IntersectionObserverを使って、ビューポートに入った時にshowButton()を呼ぶ
    this.#addIntersectionObserver();
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize);
    this.intersectionObserver.disconnect();
  }

  showButton() {
    const scrollHeight = this.$content.get(0).scrollHeight;
    const maxHeight = this.$content.css("--max-height");

    if (scrollHeight <= maxHeight) {
      this.$button.hide();
      if (this.$dummyButton) this.$dummyButton.hide();
    } else {
      this.$button.show().css("opacity", "1");
      if (this.$dummyButton) this.$dummyButton.show().css("opacity", "1");
    }
  }

  toggle(e) {
    e.stopPropagation();
    this.$button.toggleClass("is-open");
    this.$content.toggleClass("is-open");

    if (this.$content.hasClass("is-open")) {
      var h = this.$content.get(0).scrollHeight;
      this.$content.css("max-height", h);
      this.$button.text("閉じる");
    } else {
      this.$content.css("max-height", "");
      this.$button.text(this.initialButtonText);
    }
  }

  handleResize = () => {
    // リサイズ完了後
    setTimeout(() => {
      var h = this.$content.get(0).scrollHeight;

      if (this.$content.hasClass("is-open")) {
        this.$content.css("max-height", h);
      }

      this.showButton();
    }, 300);
  };

  /** this.contentTargetがビューポートに入った時 this.showButton() を呼ぶ */
  #addIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.showButton();
        }
      });
    }, options);
    this.intersectionObserver = observer;
    observer.observe(this.contentTarget);
  }
}
